<template>
  <div class="login">
    <div class="img-div">
      <div>
        <!-- <img src="../../assets/image/favicon.png" style="width:64px;height:64px;" /> -->
        <p>实训学生签到登录</p>
      </div>
    </div>
    <div class="input-div">
      <div class="input-item">
        <el-autocomplete style="width:100%;" clearable class="inline-input" v-model="schoolName" :fetch-suggestions="querySearch" placeholder="请选择学校" @select="handleSelect">
          <i class="el-icon-s-home el-input__icon" slot="prefix">
          </i>
          <template slot-scope="{ item }">
            <div class="name">{{ item.fdName }}</div>
          </template>
          <!-- <i class="el-icon-arrow-right el-input__icon" slot="suffix">
          </i> -->
        </el-autocomplete>
      </div>
      <div class="input-item">
        <el-input placeholder="请输入账号" v-model="account" clearable>
          <i class="el-icon-user el-input__icon" slot="prefix">
          </i>
        </el-input>
      </div>
      <div class="input-item">
        <el-input placeholder="请输入密码" v-model="password" show-password>
          <i class="el-icon-lock el-input__icon" slot="prefix">
          </i>
        </el-input>
      </div>
    </div>
    <div class="button-div">
      <el-button type="primary" style="width:100%;" round @click="handleLogin">登 录</el-button>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import Header from './Header.vue';
// import Menu from './Menu.vue';
// import { Toast } from 'mint-ui';

export default {
  name: 'Login',
  data() {
    return {
      token: '',
      restaurants: [],
      schoolId: '',
      schoolName: '',
      account: '',
      password: '',
    };
  },
  components: {},
  created() {},
  computed: {},
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    // this.getSchools();
  },
  methods: {
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return restaurant.fdName.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleLogin() {
      // if (!this.schoolObj) {
      //   Toast({
      //     message: '请先选择学校',
      //     position: 'middle',
      //     duration: 5000,
      //   });
      //   return;
      // }
      // if (!this.account) {
      //   Toast({
      //     message: '请先输入账号',
      //     position: 'middle',
      //     duration: 5000,
      //   });
      //   return;
      // }
      // if (!this.password) {
      //   Toast({
      //     message: '请先输入密码',
      //     position: 'middle',
      //     duration: 5000,
      //   });
      //   return;
      // }
      this.loginIn();
    },
    async loginIn() {
      this.$router.push({
        path: '/studentSignForStu',
        // query:{
        //   token:res.data.token
        // }
      });
      // let data = {
      //   j_data: `${this.account};${this.password};1`,
      //   type: 'web',
      //   school_id: this.schoolId,
      // };
      // let res = await this.$api.login.studentLogin(data);
      // console.log(res)
      // if(res.code==20000){
      //   localStorage.clear()
      //   if(res.data.token){
      //     localStorage.setItem('isdd','1')
      //   this.$router.push({
      //     path:'/testTansform',
      //     query:{
      //       token:res.data.token
      //     }
      //   })

      //   }
      // }else{
      //   Toast({
      //     message: res.message,
      //     position: 'middle',
      //     duration: 5000,
      //   });
      // }
    },
    handleSelect(item) {
      // console.log(item);
      this.schoolId = item.id;
      this.schoolName = item.fdName;
      this.schoolObj = item;
    },
    async getSchools() {
      let res = await this.$api.instance.getSchools();
      if (res.code == 0) {
        this.restaurants = res.data;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.login {
  height: 100vh;
  width: 100%;
  .img-div {
    height: 35vh;
    div {
      position: relative;
      top: 50%; /*偏移*/
      margin-top: -50px;
    }
    img {
      width: 64px;
      height: 64px;
    }
    p {
      margin-top: 8px;
      font-size: 14px;
    }
  }
  .input-div {
    // height: 30vh;
    padding: 32px 40px 54px;
    .input-item {
      margin-top: 12px;
    }
    /deep/.el-input__inner {
      border: 0;
      border-bottom: 1px solid #cecdcd;
      border-radius: 0;
      font-size: 12px;
    }
    /deep/.el-input__icon {
      font-size: 18px;
      color: #555;
      line-height: 36px;
    }
    /deep/.el-input--prefix .el-input__inner {
      padding-left: 40px;
    }
  }
  .button-div {
    padding: 0 40px;
    /deep/.el-button--primary {
      background-color: #1690ed;
      border-color: #1690ed;
    }
  }
  // background: #acbfa8;
}
</style>
